(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("queta", [], factory);
	else if(typeof exports === 'object')
		exports["queta"] = factory();
	else
		root["queta"] = factory();
})(self, function() {
return 